import { render, staticRenderFns } from "./small-groups-filter.vue?vue&type=template&id=b74703f2"
import script from "./small-groups-filter.vue?vue&type=script&lang=js"
export * from "./small-groups-filter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports